import { useAuth } from '../contexts/AuthContext';
import Navbar from '../components/Navbar';
import LiveScores from '../components/LiveScores';
import GroundOfTheWeek from '../components/GroundOfTheWeek';
import CurrentRoundStats from '../components/CurrentRoundStats';
import CurrentWeekTips from '../components/CurrentWeekTips';
import LiveTicker from '../components/LiveTicker';
import SeasonEndAnnouncement from '../components/SeasonEndAnnouncement';
import FormGuideStrip from '../components/FormGuideStrip';

export default function DashboardPage() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Ground of the Week - full width banner */}
      <GroundOfTheWeek />

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-6 py-8">
        {/* Welcome Section */}
        <div className="mb-10">
          <h1 className="text-4xl sm:text-5xl font-black uppercase tracking-tighter mb-2" data-testid="dashboard-heading">
            Dashboard
          </h1>
          <p className="text-gray-500 text-lg">Your tipping at a glance</p>
        </div>

        {/* Season-end celebration banner(s) — auto-appears once when a comp closes */}
        <SeasonEndAnnouncement />

        {/* Live now — appears only while games are in progress */}
        <LiveTicker />

        {/* Current Round Statistics */}
        <FormGuideStrip currentUserId={user?.user_id} />
        <div className="mb-12">
          <CurrentRoundStats currentUserId={user?.user_id} />
        </div>

        {/* Live Scores — full width now that the leaderboard sits alongside Round Stats */}
        <div className="mb-12">
          <LiveScores />
        </div>

        {/* Current Week Tips Matrix */}
        <div className="mb-12">
          <CurrentWeekTips currentUserId={user?.user_id} />
        </div>
      </main>
    </div>
  );
}
